<template>
  <div class="loader" @click="tap">
    <!-- <div class="loader__allow">
      <span>Please tap 'Allow' to enable camera</span>
    </div> -->

    <div v-if="state === 'loading'" class="loader__spinner"></div>
    <transition @enter="enter" appear>
      <div v-if="state === 'allowed' && loaded" class="loader__tap">
        <img src="/tap.png" alt="Tap Here">
        <span>Discover the<br><u>Q-Uno</u></span>
      </div>
    </transition>
    <div v-if="state === 'denied' && loaded" class="loader__denied">
      <span>This website needs to use camera</span>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'Loader',

  data() {
    return {
      audio: null,
      loaded: false,
      state: 'loading',
    };
  },

  mounted() {
    this.audio = new Audio('/bg.mp3');
    this.audio.load();
    const i = new Image();
    i.src = '/tap.png';
    if (typeof i.decode !== 'undefined') i.decode();

    window.addEventListener('loaddone', () => {
      this.loaded = true;
    });
    window.addEventListener('cameraallow', () => {
      this.state = 'allowed';
    });
    window.addEventListener('cameraerror', () => {
      this.state = 'denied';
    });
  },

  methods: {
    tap() {
      if (this.state !== 'allowed') return;
      window.dispatchEvent(new CustomEvent('tapped'));
      this.audio.play();
    },
    enter(el, done) {
      const hand = el.querySelector('img');
      const text = el.querySelector('span');
      gsap.set(hand, { autoAlpha: 0, y: -30 });
      gsap.set(text, { autoAlpha: 0, y: 30 });
      gsap.to(hand, { autoAlpha: 1, y: 0, duration: 1.2 });
      gsap.to(text, { autoAlpha: 1, y: 0, duration: 1.2 }).then(done);
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  color: white;

  z-index: 4;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1.4em;

  &__allow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  &__spinner {
    width: 60px;
    height: 60px;
    border: 1px dashed white;
    border-radius: 100%;
    animation-name: rotate;
    animation-iteration-count: infinite;
    animation-duration: 1s;
    animation-timing-function: linear;

    @keyframes rotate {
      0% { transform: rotate(0deg) }
      100% { transform: rotate(360deg) }
    }
  }

  &__tap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    text-align: center;

    img {
      width: 40px;
      margin-bottom: 20px;
    }
  }
}
</style>
